import { AccountLayout } from "./AccountLayout";

export const ProfileLayout = props => {
  return (
    <AccountLayout location={props.location}>
      {props.children}
    </AccountLayout>
  );
};
